import script from "./TraitShopCardCount.vue?vue&type=script&setup=true&lang=js"
export * from "./TraitShopCardCount.vue?vue&type=script&setup=true&lang=js"

import "./TraitShopCardCount.vue?vue&type=style&index=0&id=67fd01be&lang=scss"

const __exports__ = script;

export default __exports__